/**
 * Pure helpers for the Elite vs Elite Prime compare accordion.
 * Kept out of React components so a11y labels stay testable without mounting UI,
 * and so CMS/benefit-tab wiring stays in one place.
 */

import type { CompareAvailability } from '../../types/compare.types'
import {
  benefitInfoContentMap,
  eliteBenefitInfoTabTitles,
  type BenefitInfoContent
} from '../../../new-elite-landing/components/NewEliteLandingPageBenefits'
import { elitePrimeBenefitInfoContentMap } from '../../elitePlansFeatureBenefits'

/**
 * Benefit-info sheet tabs for compare-row info buttons.
 * Extends the shared Elite benefit tabs with Prime-only topics that appear
 * only in this accordion's info sheet.
 */
export const compareBenefitTabTitles = [
  ...eliteBenefitInfoTabTitles,
  'Power Allocation',
  'SIP Strategy',
  'Allocation Strategy',
  'Investment Strategy',
  'Withdrawal Strategy'
]

/** Elite benefit map + Prime strategy tabs used by compare-row info buttons. */
export const compareBenefitInfoMap: Record<string, BenefitInfoContent> = {
  ...benefitInfoContentMap,
  'Allocation Strategy': elitePrimeBenefitInfoContentMap['Allocation Strategy'],
  'Investment Strategy': elitePrimeBenefitInfoContentMap['Investment Strategy'],
  'Withdrawal Strategy': elitePrimeBenefitInfoContentMap['Withdrawal Strategy']
}

/** Screen-reader label for a plan cell's availability glyph. */
export function availabilityLabel(availability: CompareAvailability): string {
  if (availability === 'check') {
    return 'included'
  }
  if (availability === 'lock') {
    return 'locked'
  }
  return 'coming soon'
}
